import { useMemo } from "react";

import { VITE_BASE_URL_LEGACY } from "@/constants";

import { IPowerBIDashboard } from "../models/IPowerBIDashboard";

type DashboardPowerBiProps = {
  dashboard: IPowerBIDashboard;
};

export const DashboardPowerBi = ({ dashboard }: DashboardPowerBiProps) => {
  const src = useMemo(() => {
    return `${VITE_BASE_URL_LEGACY}/PowerBiEmbedded?reportId=${dashboard.reportId}&groupId=${dashboard.groupId}`;
  }, [dashboard.reportId, dashboard.groupId]);

  return (
    <iframe
      sandbox="allow-scripts allow-same-origin allow-downloads"
      src={src}
      style={{ height: "100dvh", width: "100%" }}
    />
  );
};
